import { render, staticRenderFns } from "./CompanyTabReports.vue?vue&type=template&id=cf8d9b9a&scoped=true&"
import script from "./CompanyTabReports.vue?vue&type=script&lang=ts&"
export * from "./CompanyTabReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8d9b9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
